export enum OrbitEndRoundStep {
  WAITING_SIGNATURE,
  VALIDATING_TRANSACTION,
  ENDED,
  INSUFFICIENT_GAS,
  UNKNOWN_ERROR,
  DEADLINE_EXCEEDED,
  REJECTED_BY_THE_USER,
}
